/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Preview_LoadingInputs */



/**
* | output |
* | --- |
* | "Computing…" |
*
* @param {Spaces_Modular_Wizard_Preview_LoadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_preview_loading = /** @type {((inputs?: Spaces_Modular_Wizard_Preview_LoadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Preview_LoadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird berechnet …")
	return /** @type {LocalizedString} */ ("Computing…")
});